import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../environment.ts/environment';

/**
 * Interface for subscription cancellation request
 */
export interface CancelSubscriptionRequest {
  id_site: number;
  email: string;
  origine: string;
  raison?: string;
}

/**
 * Interface for subscription cancellation data
 */
export interface CancellationData {
  status: 'cancelled' | 'already_unsubscribed';
  message: string;
}

/**
 * Interface for subscription cancellation response
 */
export interface CancelSubscriptionResponse {
  success: boolean;
  data: CancellationData;
}

@Injectable({
  providedIn: 'root'
})
export class DesabonnementService {
  private readonly apiBaseUrl = environment.apiBaseUrl;

  constructor(private http: HttpClient) {}

  /**
   * Annule un abonnement
   * @param data - Les données de la requête d'annulation
   * @returns Observable<CancelSubscriptionResponse> - La réponse de l'API
   */
  cancelSubscription(data: CancelSubscriptionRequest): Observable<CancelSubscriptionResponse> {
    console.log('Annulation abonnement avec les données:', JSON.stringify(data, null, 2));
    
    return this.http.post<CancelSubscriptionResponse>(
      `${this.apiBaseUrl}/subscriptions/cancel`,
      data,
      {
        headers: {
          'Content-Type': 'application/json',
        }
      }
    ).pipe(
      catchError(this.handleError)
    );
  }

  /**
   * Gère les erreurs HTTP
   * @param error - L'erreur HTTP
   * @returns Observable<never> - Erreur transformée
   */
  private handleError(error: HttpErrorResponse): Observable<never> {
    console.error('Erreur annulation abonnement:', {
      status: error.status,
      statusText: error.statusText,
      data: error.error,
    });

    let errorMessage = 'Erreur lors de l\'annulation de l\'abonnement';
    
    if (error.error && typeof error.error === 'object' && 'message' in error.error) {
      errorMessage = String(error.error.message);
    } else if (error.error && typeof error.error === 'string') {
      errorMessage = error.error;
    }

    return throwError(() => new Error(errorMessage));
  }
}
